module.exports = __webpack_public_path__ + "static/media/furnitures.a7bdcf3f.svg";